import AIChangingTheWorld from "@/components/blog/article-content/AIChangingTheWorld";
import AIDalamSeni from "@/components/blog/article-content/AIDalamSeni";
import AIInEducation from "@/components/blog/article-content/AIInEducation";
import AlgorithmsAndDataStructures from "@/components/blog/article-content/AlgorithmAndDS";
import CodingDiFinlandia from "@/components/blog/article-content/CodingFinlandia";
import CodingPython from "@/components/blog/article-content/CodingPython";
import EthicalHackingPython from "@/components/blog/article-content/EthicalHacking";
import GenerasiAI from "@/components/blog/article-content/GenerasiAI";
import IITChallenge2024 from "@/components/blog/article-content/IITChallenge2024";
import IITKorea from "@/components/blog/article-content/IITKorea";
import InnovativeTechChallenge from "@/components/blog/article-content/InnovativeTechChallenge";
import MachineLearning from "@/components/blog/article-content/MachineLearning";
import MitosAIFakta from "@/components/blog/article-content/MitosAI";
import ObstacleAvoidanceGame from "@/components/blog/article-content/ObstacleAvoidanceGame";
import ProgrammingBasics from "@/components/blog/article-content/ProgrammingBasic";
import ProyekRobotikRumahan from "@/components/blog/article-content/ProyekRobotikRumahan";
import PythonVsJavaScript from "@/components/blog/article-content/PythonvsJS";
import RobotPenyapuJalan from "@/components/blog/article-content/RobotPenyapuJalan";
import RobotPertanianCerdas from "@/components/blog/article-content/RobotPertanian";
import RobotsTransformingIndustries from "@/components/blog/article-content/RobotsIndustries";
import StudentSymposium from "@/components/blog/article-content/StudentSymposium";
import SumoRobotCompetition from "@/components/blog/article-content/SumoRobotCompetition";
import KeseruanBazaar from "@/components/blog/article-content/KeseruanBazaarIIT2024";
import ListJuriIIT2024 from "@/components/blog/article-content/ListJuriIIT2024";
import ListSekolahIIT2024 from "@/components/blog/article-content/ListSekolahIIT2024";
import SponsorKassow2024 from "@/components/blog/article-content/SponsorKassow2024";
import IITChallenges from "@/components/blog/article-content/IITChallenges";
import CodingJuniorWinnersList from "@/components/blog/article-content/CodingJuniorWinnersList";
import CodingSeniorWinnersList from "@/components/blog/article-content/CodingSeniorWinnersList";
import InnovativeJuniorWinnersList from "@/components/blog/article-content/InnovativeJuniorWinnersList";
import InnovativeSeniorWinnersList from "@/components/blog/article-content/InnovativeSeniorWinnersList";
import RobotSumoWinnersList from "@/components/blog/article-content/RobotSumoWinnersList";
import ObstacleRobotWinnersList from "@/components/blog/article-content/ObstacleRobotWinnersList";
import StudentSymposiumWinnersList from "@/components/blog/article-content/StudentSymposiumWinnersList";
import TipsSuksesCoding from "@/components/blog/article-content/TipsSuksesCoding";
import AlgoritmaCommon from "@/components/blog/article-content/AlgoritmaCommon";
import KenapaCoding from "@/components/blog/article-content/KenapaCoding";
import WebsiteCoding from "@/components/blog/article-content/WebsiteCoding";
import GakHarusSulit from "@/components/blog/article-content/GakHarusSulit";
import ApaItuRobotika from "@/components/blog/article-content/ApaItuRobotika";
import KomponenUtama from "@/components/blog/article-content/KomponenUtama";
import LombaRobotKeren from "@/components/blog/article-content/LombaRobotKeren";
import PerbedaanRobot from "@/components/blog/article-content/PerbedaanRobot";
import BahasaRobotik from "@/components/blog/article-content/BahasaRobotik";
import ApaItuAI from "@/components/blog/article-content/ApaItuAI";
import ContohPenggunaanAI from "@/components/blog/article-content/ContohPenggunaanAI";
import JenisAI from "@/components/blog/article-content/JenisAI";
import AITools from "@/components/blog/article-content/AITools";
import EtikaAI from "@/components/blog/article-content/EtikaAI";
import AduLogika from "@/components/blog/article-content/AduLogika";
import InovasiLewatResearchPaper from "@/components/blog/article-content/InovasiLewatResearchPaper";
import InovatorMuda from "@/components/blog/article-content/InovatorMuda";
import TantanganMengemudi from "@/components/blog/article-content/TantanganMengemudi";
import DuelSengit from "@/components/blog/article-content/DuelSengit";
import SumoRobotTeknologi from "@/components/blog/article-content/SumoRobotTeknologi";
import SumoRobotSaranaBelajar from "@/components/blog/article-content/SumoRobotSaranaBelajar";
import MengasahLogikaAIObstacle from "@/components/blog/article-content/MengasahLogikaAIObstacle";
import SaranaBelajarRobotikObstacle from "@/components/blog/article-content/SaranaBelajarRobotikObstacle";
import SymposiumPengembanganRiset from "@/components/blog/article-content/SymposiumPengembanganRiset";
import SymposiumMenulisIlmiah from "@/components/blog/article-content/SymposiumMenulisIlmiah";
import ScratchCodingKreatif from "@/components/blog/article-content/ScratchCodingKreatif";
import MengembangkanKreatifitasScratch from "@/components/blog/article-content/MengembangkanKreatifitasScratch";
import DibalikLayarUIUX from "@/components/blog/article-content/DibalikLayarUIUX";
import TantanganUIUXEraAI from "@/components/blog/article-content/TantanganUIUXEraAI";
import InnovativeWadahKreatifitas from "@/components/blog/article-content/InnovativeWadahKreativitas";
import InnovativeAjangInovasi from "@/components/blog/article-content/InnovativeAjangInovasi";
import PythonPengembanganLogika from "@/components/blog/article-content/PythonPengembanganLogika";
import PythonInovasiDigital from "@/components/blog/article-content/PythonInovasiDigital";
import VibeCodingKreativitas from "@/components/blog/article-content/VibeCodingKreativitas";
import VibeCodingTanpaCoding from "@/components/blog/article-content/VibeCodingTanpaCoding";
import StrategiAlgoritmaCP from "@/components/blog/article-content/StrategiAlgoritmaCP";
import ManajemenWaktuCP from "@/components/blog/article-content/ManajemenWaktuCP";
import MerancangGameScratch from "@/components/blog/article-content/MerancangGameScratch";
import StorytellingGameScratch from "@/components/blog/article-content/StorytellingGameScratch";
import EcoQuestEdukasiLingkungan from "@/components/blog/article-content/EcoQuestEdukasiLingkungan";
import GamifikasiDesaEcoQuest from "@/components/blog/article-content/GamifikasiDesaEcoQuest";
import InovasiIoTAIEraDigital from "@/components/blog/article-content/InovasiIoTAIEraDigital";
import DariPrototipeKeProdukSolutif from "@/components/blog/article-content/DariPrototipeKeProdukSolutif";
import StrukturDataNonLinierCP from "@/components/blog/article-content/StrukturDataNonLinierCP";
import SeniDebuggingKontes from "@/components/blog/article-content/SeniDebuggingKontes";
import LogikaMatematikaKombinatorika from "@/components/blog/article-content/LogikaMatematikaKombinatorika";
import BahasaCPlusPlusModernCP from "@/components/blog/article-content/BahasaCPlusPlusModernCP";
import StrategiSimulasiKontesTim from "@/components/blog/article-content/StrategiSimulasiKontesTim";
import MekanikFisikaGameScratch from "@/components/blog/article-content/MekanikFisikaGameScratch";
import DesainLevelInteraktifScratch from "@/components/blog/article-content/DesainLevelInteraktifScratch";
import SuaraDanAtmosferGameScratch from "@/components/blog/article-content/SuaraDanAtmosferGameScratch";
import AIKarakterSederhanaScratch from "@/components/blog/article-content/AIKarakterSederhanaScratch";
import KolaborasiRemixKomunitasScratch from "@/components/blog/article-content/KolaborasiRemixKomunitasScratch";
import SistemCMSDesaRamahAdmin from "@/components/blog/article-content/SistemCMSDesaRamahAdmin";
import PetaInteraktifGISDesa from "@/components/blog/article-content/PetaInteraktifGISDesa";
import IntegrasiUMKMDanECommerceDesa from "@/components/blog/article-content/IntegrasiUMKMDanECommerceDesa";
import KeamananDataInformasiDesa from "@/components/blog/article-content/KeamananDataInformasiDesa";
import PemberdayaanPemudaDesaDigital from "@/components/blog/article-content/PemberdayaanPemudaDesaDigital";
import SensorKualitasAirCerdas from "@/components/blog/article-content/SensorKualitasAirCerdas";
import EnergiTerbarukanMikrogrid from "@/components/blog/article-content/EnergiTerbarukanMikrogrid";
import OtomasiDaurUlangPlastik from "@/components/blog/article-content/OtomasiDaurUlangPlastik";
import SistemPeringatanDiniBencana from "@/components/blog/article-content/SistemPeringatanDiniBencana";
import DesainErgonomisHardwareInovasi from "@/components/blog/article-content/DesainErgonomisHardwareInovasi";
import PetaJalanTalentaDigitalIndonesia from "@/components/blog/article-content/PetaJalanTalentaDigitalIndonesia";
import KreativitasGenerasiZDiEraAI from "@/components/blog/article-content/KreativitasGenerasiZDiEraAI";
import KolaborasiLembagaDanSekolah from "@/components/blog/article-content/KolaborasiLembagaDanSekolah";
import KesehatanMentalPengembangMuda from "@/components/blog/article-content/KesehatanMentalPengembangMuda";
import DampakSosialInovasiPelajar from "@/components/blog/article-content/DampakSosialInovasiPelajar";

export const categories = [
  "All",
  "Competitive Programming",
  "Scratch Coding Game",
  "EcoQuest Web App",
  "Innovative Technology Challenge",
  'Event',
  'Coding',
  'Robotic',
  'Technology Creative'
] as const;
export type Category = typeof categories[number];

export interface Article {
  id: string;
  slug: string;
  title: string;
  category: Category;
  date: string;
  time: string;
  image: string;
  content: React.ReactNode;
  shortDescription: string;
}

export function slugify(text: string): string {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[\s\W-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
const monthMap = {
  Januari: 'January',
  Februari: 'February',
  Maret: 'March',
  April: 'April',
  Mei: 'May',
  Juni: 'June',
  Juli: 'July',
  Agustus: 'August',
  September: 'September',
  Oktober: 'October',
  November: 'November',
  Desember: 'December'
};

export function normalizeDate(dateStr) {
  const monthRegex = new RegExp(Object.keys(monthMap).join('|'), 'i');
  return dateStr.replace(monthRegex, match => monthMap[match]);
}

export const articles: Article[] = [
  // --- COMPETITIVE PROGRAMMING ---
  {
    id: 'cp-1',
    slug: slugify('Strategi Efektif Menguasai Algoritma dan Struktur Data dalam Competitive Programming'),
    title: 'Strategi Efektif Menguasai Algoritma dan Struktur Data dalam Competitive Programming',
    category: 'Competitive Programming',
    date: 'Januari 18, 2025',
    time: '14:00',
    image: '/images/blog/StrategiAlgoritmaCP.jpg',
    content: <StrategiAlgoritmaCP />,
    shortDescription: 'Competitive Programming menguji kemampuan problem-solving melalui penguasaan struktur data fundamental, analisis algoritma, dan optimasi efisiensi kode.'
  },
  {
    id: 'cp-2',
    slug: slugify('Pentingnya Time Complexity dan Manajemen Waktu dalam Kompetisi Pemrograman'),
    title: 'Pentingnya Time Complexity dan Manajemen Waktu dalam Kompetisi Pemrograman',
    category: 'Competitive Programming',
    date: 'Februari 24, 2025',
    time: '15:30',
    image: '/images/blog/ManajemenWaktuCP.jpg',
    content: <ManajemenWaktuCP />,
    shortDescription: 'Hindari Time Limit Exceeded (TLE) dengan pemahaman Big-O notation dan strategi manajemen waktu yang disiplin saat kontes pemrograman berlangsung.'
  },
  {
    id: 'cp-3',
    slug: slugify('Menyelami Struktur Data Segment Tree dan Fenwick Tree dalam Range Query Competitive Programming'),
    title: 'Menyelami Struktur Data Segment Tree dan Fenwick Tree dalam Range Query Competitive Programming',
    category: 'Competitive Programming',
    date: 'Januari 15, 2025',
    time: '14:00',
    image: '/images/blog/StrukturDataNonLinierCP.jpg',
    content: <StrukturDataNonLinierCP />,
    shortDescription: 'Dalam dunia Competitive Programming tingkat lanjut, penguasaan struktur data Segment Tree dan Fenwick Tree menjadi senjata ampuh untuk menyelesaikan persoalan range query dalam kompleksitas O(log N).'
  },
  {
    id: 'cp-4',
    slug: slugify('Seni Menemukan Bug Tersembunyi: Teknik Stress Testing dan Generator Kasus Uji Otomatis'),
    title: 'Seni Menemukan Bug Tersembunyi: Teknik Stress Testing dan Generator Kasus Uji Otomatis',
    category: 'Competitive Programming',
    date: 'Februari 10, 2025',
    time: '15:30',
    image: '/images/blog/SeniDebuggingKontes.jpg',
    content: <SeniDebuggingKontes />,
    shortDescription: 'Mendapatkan status Wrong Answer tanpa mengetahui testcase yang gagal? Pelajari metode stress testing otomatis dengan generator data acak untuk menemukan minimal counterexample secara cepat.'
  },
  {
    id: 'cp-5',
    slug: slugify('Penerapan Teori Bilangan dan Kombinatorika Diskrit untuk Menembus Limit Komputasi'),
    title: 'Penerapan Teori Bilangan dan Kombinatorika Diskrit untuk Menembus Limit Komputasi',
    category: 'Competitive Programming',
    date: 'Maret 05, 2025',
    time: '10:00',
    image: '/images/blog/LogikaMatematikaKombinatorika.jpg',
    content: <LogikaMatematikaKombinatorika />,
    shortDescription: 'Membedah korelasi mendalam antara ilmu komputer dan matematika diskrit, mulai dari Teorema Fermat, invers modular, hingga rumus kombinatorika untuk efisiensi komputasi tingkat tinggi.'
  },
  {
    id: 'cp-6',
    slug: slugify('Keunggulan Fitur C++ Modern dan Standard Template Library dalam Kecepatan Eksekusi Kontes'),
    title: 'Keunggulan Fitur C++ Modern dan Standard Template Library dalam Kecepatan Eksekusi Kontes',
    category: 'Competitive Programming',
    date: 'April 12, 2025',
    time: '13:15',
    image: '/images/blog/BahasaCPlusPlusModernCP.jpg',
    content: <BahasaCPlusPlusModernCP />,
    shortDescription: 'Mengapa C++ tetap menjadi raja di panggung ICPC dan IOI? Eksplorasi fitur C++ modern, optimalisasi STL container, dan fungsi bitwise bawaan yang memangkas waktu pengerjaan.'
  },
  {
    id: 'cp-7',
    slug: slugify('Dinamika Kerja Sama Tim Kontes Pemrograman: Manajemen Satu Komputer dan Pembagian Peran Efektif'),
    title: 'Dinamika Kerja Sama Tim Kontes Pemrograman: Manajemen Satu Komputer dan Pembagian Peran Efektif',
    category: 'Competitive Programming',
    date: 'Mei 18, 2025',
    time: '16:45',
    image: '/images/blog/StrategiSimulasiKontesTim.jpg',
    content: <StrategiSimulasiKontesTim />,
    shortDescription: 'Tiga programmer, satu komputer, dan lima jam penuh tantangan. Simak panduan taktis pembagian peran Reader, Implementer, dan Thinker dalam kontes beregu berstandar ICPC.'
  },

  // --- SCRATCH CODING GAME ---
  {
    id: 'sc-1',
    slug: slugify('Merancang Game Interaktif dan Edukatif Menggunakan Scratch untuk Pemula'),
    title: 'Merancang Game Interaktif dan Edukatif Menggunakan Scratch untuk Pemula',
    category: 'Scratch Coding Game',
    date: 'Maret 15, 2025',
    time: '10:00',
    image: '/images/blog/MerancangGameScratch.jpeg',
    content: <MerancangGameScratch />,
    shortDescription: 'Panduan langkah demi langkah mengubah ide imajinatif menjadi game interaktif berbasis visual block coding di platform Scratch.'
  },
  {
    id: 'sc-2',
    slug: slugify('Mengasah Logika dan Storytelling Interaktif Anak Melalui Game Development di Scratch'),
    title: 'Mengasah Logika dan Storytelling Interaktif Anak Melalui Game Development di Scratch',
    category: 'Scratch Coding Game',
    date: 'April 20, 2025',
    time: '11:15',
    image: '/images/blog/StorytellingGameScratch.jpg',
    content: <StorytellingGameScratch />,
    shortDescription: 'Bagaimana pembuatan game di Scratch melatih computational thinking, pemahaman alur sebab-akibat, dan kreativitas storytelling interaktif.'
  },
  {
    id: 'sc-3',
    slug: slugify('Eksplorasi Gravitasi, Akselerasi, dan Pantulan pada Game Platformer Scratch'),
    title: 'Eksplorasi Gravitasi, Akselerasi, dan Pantulan pada Game Platformer Scratch',
    category: 'Scratch Coding Game',
    date: 'Januari 20, 2025',
    time: '11:00',
    image: '/images/blog/MekanikFisikaGameScratch.jpg',
    content: <MekanikFisikaGameScratch />,
    shortDescription: 'Pelajari cara menyimulasikan hukum fisika seperti gravitasi, inersia gaya gesek, dan deteksi tumbukan lantai agar gerakan karakter game di Scratch terasa mulus dan realistis.'
  },
  {
    id: 'sc-4',
    slug: slugify('Prinsip Merancang Level Desain Game Interaktif yang Menantang Namun Ramah Pemula'),
    title: 'Prinsip Merancang Level Desain Game Interaktif yang Menantang Namun Ramah Pemula',
    category: 'Scratch Coding Game',
    date: 'Februari 15, 2025',
    time: '09:30',
    image: '/images/blog/DesainLevelInteraktifScratch.jpg',
    content: <DesainLevelInteraktifScratch />,
    shortDescription: 'Menerapkan metodologi desain level 4 tahap (Kishotenketsu) dan sistem broadcast message untuk menciptakan kurva tantangan game yang adiktif dan menyenangkan bagi pemain.'
  },
  {
    id: 'sc-5',
    slug: slugify('Menghidupkan Atmosfer Game Melalui Sinkronisasi Tata Suara dan Musik Latar Interaktif'),
    title: 'Menghidupkan Atmosfer Game Melalui Sinkronisasi Tata Suara dan Musik Latar Interaktif',
    category: 'Scratch Coding Game',
    date: 'Maret 22, 2025',
    time: '14:20',
    image: '/images/blog/SuaraDanAtmosferGameScratch.jpg',
    content: <SuaraDanAtmosferGameScratch />,
    shortDescription: 'Suara bukan sekadar pemanis, melainkan audio feedback penting yang membangun emosi. Eksplorasi teknik penyuntingan audio kustom dan musik latar dinamis di platform Scratch.'
  },
  {
    id: 'sc-6',
    slug: slugify('Memprogram Kecerdasan Buatan Lawan yang Dinamis Menggunakan Logika Penjejak Vektor di Scratch'),
    title: 'Memprogram Kecerdasan Buatan Lawan yang Dinamis Menggunakan Logika Penjejak Vektor di Scratch',
    category: 'Scratch Coding Game',
    date: 'April 28, 2025',
    time: '15:00',
    image: '/images/blog/AIKarakterSederhanaScratch.png',
    content: <AIKarakterSederhanaScratch />,
    shortDescription: 'Tingkatkan keseruan permainan dengan merancang musuh cerdas berpola Chaser, Patrol, dan Turret menggunakan komparasi koordinat serta kloning proyektil otomatis.'
  },
  {
    id: 'sc-7',
    slug: slugify('Kekuatan Fitur Remix Komunitas Scratch: Belajar dari Kode Terbuka Global Tanpa Menjiplak'),
    title: 'Kekuatan Fitur Remix Komunitas Scratch: Belajar dari Kode Terbuka Global Tanpa Menjiplak',
    category: 'Scratch Coding Game',
    date: 'Mei 25, 2025',
    time: '10:45',
    image: '/images/blog/KolaborasiRemixKomunitasScratch.png',
    content: <KolaborasiRemixKomunitasScratch />,
    shortDescription: 'Menanamkan filosofi open source sejak dini: bagaimana fitur remix melatih siswa melakukan reverse engineering, berkolaborasi positif, dan menghormati hak cipta karya digital.'
  },

  // --- ECOQUEST VILLAGE WEBSITE APPLICATION ---
  {
    id: 'eq-1',
    slug: slugify('Membangun Website Interaktif EcoQuest Village: Menghubungkan Edukasi Lingkungan dan Web Development'),
    title: 'Membangun Website Interaktif EcoQuest Village: Menghubungkan Edukasi Lingkungan dan Web Development',
    category: 'EcoQuest Web App',
    date: 'Mei 12, 2025',
    time: '13:00',
    image: '/images/blog/EcoQuestEdukasiLingkungan.jpeg',
    content: <EcoQuestEdukasiLingkungan />,
    shortDescription: 'Membangun platform aplikasi web edukatif bertema pelestarian lingkungan desa dengan desain antarmuka yang responsif dan ramah pengguna.'
  },
  {
    id: 'eq-2',
    slug: slugify('Integrasi Gamifikasi dan Responsivitas UI pada Aplikasi Web Desa Ramah Lingkungan'),
    title: 'Integrasi Gamifikasi dan Responsivitas UI pada Aplikasi Web Desa Ramah Lingkungan',
    category: 'EcoQuest Web App',
    date: 'Juni 19, 2025',
    time: '16:00',
    image: '/images/blog/GamifikasiDesaEcoQuest.jpg',
    content: <GamifikasiDesaEcoQuest />,
    shortDescription: 'Meningkatkan partisipasi warga dalam aksi hijau melalui fitur gamifikasi, sistem poin tantangan harian, dan antarmuka web modern.'
  },
  {
    id: 'eq-3',
    slug: slugify('Merancang Dashboard CMS Desa yang Intuitif untuk Perangkat Desa Non-Teknis'),
    title: 'Merancang Dashboard CMS Desa yang Intuitif untuk Perangkat Desa Non-Teknis',
    category: 'EcoQuest Web App',
    date: 'Februari 02, 2025',
    time: '13:00',
    image: '/images/blog/SistemCMSDesaRamahAdmin.jpg',
    content: <SistemCMSDesaRamahAdmin />,
    shortDescription: 'Portal desa yang sukses menuntut pengelolaan yang mudah. Simak arsitektur dashboard CMS ramah pengguna, editor visual WYSIWYG, dan manajemen hak akses terintegrasi.'
  },
  {
    id: 'eq-4',
    slug: slugify('Pemanfaatan Web GIS untuk Memetakan Potensi Wisata, Fasilitas Publik, dan Kawasan Hijau Desa'),
    title: 'Pemanfaatan Web GIS untuk Memetakan Potensi Wisata, Fasilitas Publik, dan Kawasan Hijau Desa',
    category: 'EcoQuest Web App',
    date: 'Maret 18, 2025',
    time: '11:15',
    image: '/images/blog/PetaInteraktifGISDesa.jpg',
    content: <PetaInteraktifGISDesa />,
    shortDescription: 'Mengintegrasikan data spasial dan pustaka pemetaan ringan Leaflet.js ke dalam website desa guna menyajikan peta interaktif fasilitas publik, rute UMKM, dan zonasi hijau.'
  },
  {
    id: 'eq-5',
    slug: slugify('Mendorong Ekonomi Lokal Lewat Etalase Digital Produk Unggulan dan Kerajinan Desa'),
    title: 'Mendorong Ekonomi Lokal Lewat Etalase Digital Produk Unggulan dan Kerajinan Desa',
    category: 'EcoQuest Web App',
    date: 'April 08, 2025',
    time: '16:00',
    image: '/images/blog/IntegrasiUMKMDanECommerceDesa.png',
    content: <IntegrasiUMKMDanECommerceDesa />,
    shortDescription: 'Menghubungkan produk organik dan kerajinan warga desa ke pasar nasional melalui katalog digital terpadu berkonsep direct-to-consumer tanpa potongan komisi perantara.'
  },
  {
    id: 'eq-6',
    slug: slugify('Prinsip Keamanan Siber pada Portal Publik Desa: Melindungi Integritas Data Kependudukan'),
    title: 'Prinsip Keamanan Siber pada Portal Publik Desa: Melindungi Integritas Data Kependudukan',
    category: 'EcoQuest Web App',
    date: 'Mei 14, 2025',
    time: '09:00',
    image: '/images/blog/KeamananDataInformasiDesa.jpg',
    content: <KeamananDataInformasiDesa />,
    shortDescription: 'Menerapkan proteksi Prepared Statements, sanitasi input XSS, token CSRF, serta enkripsi sandi modern pada arsitektur PHP/MySQL portal desa guna mencegah kebocoran data.'
  },
  {
    id: 'eq-7',
    slug: slugify('Pemberdayaan Pemuda Desa Digital: Kisah Alih Pengetahuan Melalui Program VIP di Lapangan'),
    title: 'Pemberdayaan Pemuda Desa Digital: Kisah Alih Pengetahuan Melalui Program VIP di Lapangan',
    category: 'EcoQuest Web App',
    date: 'Juni 20, 2025',
    time: '14:30',
    image: '/images/blog/PemberdayaanPemudaDesaDigital.jpg',
    content: <PemberdayaanPemudaDesaDigital />,
    shortDescription: 'Mengintip keseruan 3 hari program pendampingan Winner’s Village Implementation Program di Desa Marga Mulya bersama Karang Taruna dan perangkat desa setempat.'
  },

  // --- INNOVATIVE TECHNOLOGY CHALLENGE ---
  {
    id: 'itc-1',
    slug: slugify('Pemanfaatan Internet of Things (IoT) dan AI untuk Solusi Nyata di Innovative Technology Challenge'),
    title: 'Pemanfaatan Internet of Things (IoT) dan AI untuk Solusi Nyata di Innovative Technology Challenge',
    category: 'Innovative Technology Challenge',
    date: 'Juli 22, 2025',
    time: '09:45',
    image: '/images/blog/InovasiIoTAIEraDigital.jpg',
    content: <InovasiIoTAIEraDigital />,
    shortDescription: 'Integrasi sensor cerdas IoT dan algoritma kecerdasan buatan dalam menciptakan inovasi nyata di bidang agrikultur, kesehatan, dan pengelolaan limbah.'
  },
  {
    id: 'itc-2',
    slug: slugify('Dari Konsep Prototipe ke Produk Solutif: Kunci Sukses Proyek di Ajang Teknologi Inovatif'),
    title: 'Dari Konsep Prototipe ke Produk Solutif: Kunci Sukses Proyek di Ajang Teknologi Inovatif',
    category: 'Innovative Technology Challenge',
    date: 'Agustus 16, 2025',
    time: '15:00',
    image: '/images/blog/DariPrototipeKeProdukSolutif.jpg',
    content: <DariPrototipeKeProdukSolutif />,
    shortDescription: 'Tahapan riset, perancangan prototipe produk solutif, validasi data, hingga tips presentasi memikat di depan dewan juri kompetisi teknologi.'
  },
  {
    id: 'itc-3',
    slug: slugify('Inovasi Monitoring Kualitas Air Sungai Berbasis Sensor IoT untuk Mitigasi Pencemaran'),
    title: 'Inovasi Monitoring Kualitas Air Sungai Berbasis Sensor IoT untuk Mitigasi Pencemaran',
    category: 'Innovative Technology Challenge',
    date: 'Januari 28, 2025',
    time: '10:00',
    image: '/images/blog/SensorKualitasAirCerdas.jpg',
    content: <SensorKualitasAirCerdas />,
    shortDescription: 'Rancang bangun pelampung pintar (Smart Buoy) bertenaga surya dengan sensor pH, kekeruhan, DO, dan TDS yang mengirimkan telemetri kualitas air secara nirkabel jarak jauh.'
  },
  {
    id: 'itc-4',
    slug: slugify('Prototipe Manajemen Daya Surya Mikrogrid untuk Fasilitas Publik dan Komunitas'),
    title: 'Prototipe Manajemen Daya Surya Mikrogrid untuk Fasilitas Publik dan Komunitas',
    category: 'Innovative Technology Challenge',
    date: 'Februari 28, 2025',
    time: '15:45',
    image: '/images/blog/EnergiTerbarukanMikrogrid.jpg',
    content: <EnergiTerbarukanMikrogrid />,
    shortDescription: 'Inovasi sistem manajemen mikrogrid pintar berbasis ESP32 dengan algoritma load shedding otomatis untuk optimalisasi distribusi energi panel surya di fasilitas umum.'
  },
  {
    id: 'itc-5',
    slug: slugify('Rancang Bangun Mesin Pemilah dan Pencacah Plastik Otomatis Berbasis Mikrokontroler'),
    title: 'Rancang Bangun Mesin Pemilah dan Pencacah Plastik Otomatis Berbasis Mikrokontroler',
    category: 'Innovative Technology Challenge',
    date: 'Maret 30, 2025',
    time: '13:30',
    image: '/images/blog/OtomasiDaurUlangPlastik.jpg',
    content: <OtomasiDaurUlangPlastik />,
    shortDescription: 'Mendorong ekonomi sirkular dari sekolah: prototipe mesin pencacah botol plastik otomatis dengan sensor pintar ganda untuk menghasilkan bahan daur ulang 3D printing.'
  },
  {
    id: 'itc-6',
    slug: slugify('Integrasi Sensor Kemiringan dan Curah Hujan untuk Sistem Deteksi Dini Bencana Longsor Mandiri'),
    title: 'Integrasi Sensor Kemiringan dan Curah Hujan untuk Sistem Deteksi Dini Bencana Longsor Mandiri',
    category: 'Innovative Technology Challenge',
    date: 'April 25, 2025',
    time: '08:45',
    image: '/images/blog/SistemPeringatanDiniBencana.jpg',
    content: <SistemPeringatanDiniBencana />,
    shortDescription: 'Membangun stasiun Early Warning System (EWS) kompak mandiri dengan transmisi radio LoRa guna memberikan peringatan evakuasi otomatis bagi warga lereng bukit rawan longsor.'
  },
  {
    id: 'itc-7',
    slug: slugify('Pentingnya Desain Casing 3D Printing Ergonomis dan Weatherproof pada Perangkat Hardware Inovasi'),
    title: 'Pentingnya Desain Casing 3D Printing Ergonomis dan Weatherproof pada Perangkat Hardware Inovasi',
    category: 'Innovative Technology Challenge',
    date: 'Mei 30, 2025',
    time: '16:15',
    image: '/images/blog/DesainErgonomisHardwareInovasi.jpg',
    content: <DesainErgonomisHardwareInovasi />,
    shortDescription: 'Prototipe yang matang dinilai dari packaging-nya. Panduan rekayasa casing 3D printing filamen PETG dengan manajemen termal dan segel tahan cuaca untuk perangkat outdoor.'
  },

  // --- GENERAL ---
  {
    id: 'gen-1',
    slug: slugify('Peta Jalan Menuju Generasi Emas: Peran Kompetisi Teknologi dalam Mengasah Skill Abad 21'),
    title: 'Peta Jalan Menuju Generasi Emas: Peran Kompetisi Teknologi dalam Mengasah Skill Abad 21',
    category: 'All',
    date: 'Juni 05, 2025',
    time: '10:00',
    image: '/images/blog/PetaJalanTalentaDigitalIndonesia.jpg',
    content: <PetaJalanTalentaDigitalIndonesia />,
    shortDescription: 'Menelaah 4 pilar keterampilan abad 21: Berpikir Komputasional, Kreativitas, Kolaborasi, dan Komunikasi Publik sebagai bekal generasi muda menjadi pencipta teknologi masa depan.'
  },
  {
    id: 'gen-2',
    slug: slugify('Menjaga Otentisitas Karya: Bagaimana Pelajar Memanfaatkan AI Generatif Tanpa Kehilangan Daya Kritis'),
    title: 'Menjaga Otentisitas Karya: Bagaimana Pelajar Memanfaatkan AI Generatif Tanpa Kehilangan Daya Kritis',
    category: 'All',
    date: 'Juni 15, 2025',
    time: '14:00',
    image: '/images/blog/KreativitasGenerasiZDiEraAI.jpg',
    content: <KreativitasGenerasiZDiEraAI />,
    shortDescription: 'Di tengah kemudahan kode instan dari AI, bagaimana pelajar mempertahankan orisinalitas nalar berpikir kritis dan pemahaman logika komputasi mendalam?'
  },
  {
    id: 'gen-3',
    slug: slugify('Sinergi Triple-Helix: Kolaborasi Lembaga Edukasi, Universitas, dan Industri dalam Riset Terapan Pelajar'),
    title: 'Sinergi Triple-Helix: Kolaborasi Lembaga Edukasi, Universitas, dan Industri dalam Riset Terapan Pelajar',
    category: 'All',
    date: 'Juli 02, 2025',
    time: '11:30',
    image: '/images/blog/KolaborasiLembagaDanSekolah.jpg',
    content: <KolaborasiLembagaDanSekolah />,
    shortDescription: 'Melihat dampak kemitraan strategis antara IIT, AEDU, TFI, dan BNCC dalam membuka akses pelatihan coding, robotika, dan inovasi web bagi ribuan siswa di seluruh Indonesia.'
  },
  {
    id: 'gen-4',
    slug: slugify('Keseimbangan Belajar dan Berkarya: Menghindari Burnout di Tengah Ambisi Kompetisi Teknologi'),
    title: 'Keseimbangan Belajar dan Berkarya: Menghindari Burnout di Tengah Ambisi Kompetisi Teknologi',
    category: 'All',
    date: 'Juli 20, 2025',
    time: '15:15',
    image: '/images/blog/KesehatanMentalPengembangMuda.jpg',
    content: <KesehatanMentalPengembangMuda />,
    shortDescription: 'Panduan menjaga kebugaran mental dan fisik bagi developer muda: teknik Pomodoro, relaksasi mata 20-20-20, serta manajemen tidur untuk performa coding yang optimal.'
  },
  {
    id: 'gen-5',
    slug: slugify('Ketika Kode dan Sirkuit Menjawab Masalah: Ragam Kisah Inspiratif Inovator Muda Tanah Air'),
    title: 'Ketika Kode dan Sirkuit Menjawab Masalah: Ragam Kisah Inspiratif Inovator Muda Tanah Air',
    category: 'All',
    date: 'Agustus 10, 2025',
    time: '16:30',
    image: '/images/blog/DampakSosialInovasiPelajar.jpg',
    content: <DampakSosialInovasiPelajar />,
    shortDescription: 'Merayakan dedikasi dan empati sosial peserta IIT Challenge: bagaimana inovasi teknologi sederhana mampu membawa perubahan nyata bagi lingkungan dan masyarakat sekitar.'
  },
  
  {
    id: '1',
    slug: slugify('Keberhasilan Indonesia Innovative Technology Challenge 2024: Meningkatkan Kreativitas Generasi Muda'),
    title: 'Keberhasilan Indonesia Innovative Technology Challenge 2024: Meningkatkan Kreativitas Generasi Muda',
    category: 'Event',
    date: 'April 30, 2024',
    time: '16:00',
    image: '/images/blog/IIT-Challenge-2024.png',
    content: <IITChallenge2024 />,
    shortDescription: 'Pada 5 Oktober 2024, Indonesia Innovative Technology Challenge (IIT Challenge) berhasil menggelar ajang tahunan yang memacu kreativitas dan inovasi generasi muda. Acara ini diselenggarakan dengan gemilang, menarik total 225 peserta dari 92 sekolah yang tersebar di berbagai daerah di Indonesia.'
  },
  {
    id: '2',
    slug: slugify('Keseruan Coding Python di Indonesia Innovative Technology Challenge 2024'),
    title: 'Keseruan Coding Python di Indonesia Innovative Technology Challenge 2024',
    category: 'Event',
    date: 'April 30, 2024',
    time: '16:00',
    image: '/images/blog/Coding-Python.jpeg',
    content: <CodingPython />,
    shortDescription: 'Kompetisi Coding Python di ajang Indonesia Innovative Technology Challenge (IIT Challenge) 2024 menjadi salah satu kategori yang paling diminati oleh peserta. '
  },
  {
    id: '3',
    slug: slugify('Keseruan Innovative Technology Challenge di IIT Challenge 2024: Level Junior dan Senior'),
    title: 'Keseruan Innovative Technology Challenge di IIT Challenge 2024: Level Junior dan Senior',
    category: 'Event',
    date: 'April 30, 2024',
    time: '16:00',
    image: '/images/blog/Innovative.png',
    content: <InnovativeTechChallenge />,
    shortDescription: 'Pada ajang Indonesia Innovative Technology Challenge (IIT Challenge) 2024, kategori Innovative Technology Challenge menjadi salah satu kompetisi yang paling menarik perhatian. Dibagi menjadi dua level, yaitu Junior untuk siswa sekolah dasar (SD) dan Senior untuk siswa SMP hingga SMA, kategori ini menggabungkan kreativitas, inovasi, dan teknologi dalam satu wadah kompetisi yang penuh semangat.'
  },
  {
    id: '4',
    slug: slugify('Keseruan Student Symposium Research Paper di IITC 2024: Menyuarakan Gagasan Tentang COVID-19 dan SDGs'),
    title: 'Keseruan Student Symposium Research Paper di IITC 2024: Menyuarakan Gagasan Tentang COVID-19 dan SDGs',
    category: 'Event',
    date: 'April 30, 2024',
    time: '16:00',
    image: '/images/blog/Symposium.jpeg',
    content: <StudentSymposium />,
    shortDescription: 'Pada ajang Indonesia Innovative Technology Challenge (IIT Challenge) 2024, kategori Student Symposium Research Paper menghadirkan kesempatan bagi siswa SMP dan SMA untuk menyuarakan gagasan mereka melalui penelitian. Dengan tema seputar pandemi COVID-19 dan Sustainable Development Goals (SDGs), peserta diajak untuk menggali isu-isu penting dunia dan mencari solusi inovatif.'
  },
  {
    id: '5',
    slug: slugify('Keseruan Kompetisi Sumo Robot di IITC 2024: Duel Robot Penuh Strategi'),
    title: 'Keseruan Kompetisi Sumo Robot di IITC 2024: Duel Robot Penuh Strategi',
    category: 'Event',
    date: 'April 30, 2024',
    time: '16:00',
    image: '/images/blog/Sumo-Game.png',
    content: <SumoRobotCompetition />,
    shortDescription: 'Kompetisi Sumo Robot menjadi salah satu kategori paling seru dan menegangkan di ajang Indonesia Innovative Technology Challenge (IITC) 2024. Dirancang untuk siswa SMP dan SMA, lomba ini menghadirkan adu kekuatan dan strategi antara robot-robot mini yang dirancang dan diprogram oleh para peserta.'
  },
  {
    id: '6',
    slug: slugify('Keseruan Kompetisi Obstacle Avoidance Driving Game di IITC 2024'),
    title: 'Keseruan Kompetisi Obstacle Avoidance Driving Game di IITC 2024',
    category: 'Event',
    date: 'April 30, 2024',
    time: '16:00',
    image: '/images/blog/Obstacle.png',
    content: <ObstacleAvoidanceGame />,
    shortDescription: 'Ajang Indonesia Innovative Technology Challenge (IITC) 2024 menghadirkan kategori unik yang memadukan teknologi, kreativitas, dan strategi dalam robotika yaitu Obstacle Avoidance Driving Game. Kompetisi ini dirancang untuk siswa SMP dan SMA agar dapat memprogram robot pintar yang mampu melewati rintangan secara otomatis di lintasan khusus.'
  },
  {
    id: '7',
    slug: slugify('Keikutsertaan Peserta Coding Junior dan Juara 3 Innovative Technology Challenge di Korea Selatan'),
    title: 'Keikutsertaan Peserta Coding Junior dan Juara 3 Innovative Technology Challenge di Korea Selatan',
    category: 'Event',
    date: 'Oktober 30, 2025',
    time: '18:00',
    image: '/images/blog/IIT-Korea-Selatan.jpg',
    content: <IITKorea />,
    shortDescription: 'Pada 2-3 November 2024, ajang Innovative Technology Challenge diadakan di Chonnam National University, Yeosu-si, Korea Selatan. Dalam kompetisi tingkat internasional ini, perwakilan Indonesia berhasil menunjukkan prestasi luar biasa, khususnya di kategori Coding Level Junior dan Innovative Technology Challenge Level Junior.'
  },
  {
    id: '8',
    slug: slugify('Apa Itu Artificial Intelligence? Penjelasan Singkat untuk Pemula'),
    title: 'Apa Itu Artificial Intelligence? Penjelasan Singkat untuk Pemula',
    category: 'Technology Creative',
    date: 'Januari 15, 2025',
    time: '16:00',
    image: '/images/blog/apaItuai.jpg',
    content: <ApaItuAI />,
    shortDescription: 'Artificial Intelligence (AI) atau Kecerdasan Buatan adalah kemampuan mesin atau komputer untuk melakukan tugas-tugas yang biasanya memerlukan kecerdasan manusia. Dengan AI, mesin bisa "berpikir", belajar dari pengalaman, memahami data, dan bahkan membuat keputusan secara mandiri'
  },
  {
    id: '8',
    slug: slugify('5 Contoh Penggunaan AI di Kehidupan Sehari-Hari'),
    title: '5 Contoh Penggunaan AI di Kehidupan Sehari-Hari',
    category: 'Technology Creative',
    date: 'Februari 7, 2025',
    time: '16:00',
    image: '/images/blog/contohpenggunaanai.jpg',
    content: <ContohPenggunaanAI />,
    shortDescription: 'Artificial Intelligence (AI) bukan lagi sekadar teknologi masa depan—ia sudah menjadi bagian dari kehidupan kita sehari-hari. Tanpa disadari, kita sering berinteraksi dengan sistem yang digerakkan oleh AI. Berikut ini adalah lima contoh nyata penerapan AI yang mungkin sudah Anda gunakan!'
  },
  {
    id: '8',
    slug: slugify('Jenis-Jenis AI: Dari Narrow AI sampai Superintelligence'),
    title: 'Jenis-Jenis AI: Dari Narrow AI sampai Superintelligence',
    category: 'Technology Creative',
    date: 'Maret 10, 2025',
    time: '16:00',
    image: '/images/blog/jenisai.jpg',
    content: <JenisAI />,
    shortDescription: 'Ketika kita berbicara tentang Artificial Intelligence (AI), penting untuk mengetahui bahwa AI tidak hanya terdiri dari satu jenis. AI dikategorikan berdasarkan kemampuannya dalam memahami, belajar, dan menyelesaikan tugas. Tiga kategori utama AI adalah sebagai berikut'
  },
  {
    id: '8',
    slug: slugify('Mau Belajar AI? Ini 4 Tools yang Bisa Kamu Coba Gratis'),
    title: 'Mau Belajar AI? Ini 4 Tools yang Bisa Kamu Coba Gratis',
    category: 'Technology Creative',
    date: 'April 4, 2025',
    time: '16:00',
    image: '/images/blog/belajarai.jpg',
    content: <AITools />,
    shortDescription: 'Ingin mulai belajar AI tapi bingung harus mulai dari mana? Jangan khawatir! Saat ini banyak tools gratis yang bisa membantumu belajar dan bereksperimen dengan AI, bahkan jika kamu belum punya pengalaman coding sekalipun. Berikut ini 4 tools yang direkomendasikan untuk pemula'
  },
  {
    id: '8',
    slug: slugify('Etika dalam AI: Kenapa Harus Diperhatikan?'),
    title: 'Etika dalam AI: Kenapa Harus Diperhatikan?',
    category: 'Technology Creative',
    date: 'Mei 20, 2025',
    time: '16:00',
    image: '/images/blog/etikaai.jpg',
    content: <EtikaAI />,
    shortDescription: 'Kecerdasan buatan (AI) terus berkembang dan diadopsi di berbagai sektor kehidupan, dari layanan kesehatan hingga keuangan, dari pendidikan hingga pemerintahan.'
  },
  {
    id: '8',
    slug: slugify('Peran AI dalam Transformasi Pendidikan di Tahun 2024'),
    title: 'Peran AI dalam Transformasi Pendidikan di Tahun 2024',
    category: 'Technology Creative',
    date: 'April 30, 2024',
    time: '16:00',
    image: '/images/blog/Ai-in-Education.png',
    content: <AIInEducation />,
    shortDescription: 'Artificial Intelligence (AI) telah menjadi salah satu teknologi paling transformatif dalam dunia pendidikan. Dengan kemampuan personalisasi pembelajaran dan otomatisasi tugas, AI membawa revolusi baru dalam cara kita belajar dan mengajar.'
  },
  {
    id: '8',
    slug: slugify('5 Tips Sukses Mengikuti Lomba Coding untuk Pemula'),
    title: '5 Tips Sukses Mengikuti Lomba Coding untuk Pemula',
    category: 'Coding',
    date: 'Januari 20, 2025',
    time: '16:00',
    image: '/images/blog/competitive-programming.jpg',
    content: <TipsSuksesCoding />,
    shortDescription: 'Baru pertama kali ikut lomba coding? Tenang, semua orang pernah jadi pemula! Berikut ini 5 tips penting biar kamu gak cuma ikut, tapi juga siap bersaing dengan percaya diri.'
  },
  {
    id: '8',
    slug: slugify('Algoritma Paling Sering Muncul di Lomba Coding'),
    title: 'Algoritma Paling Sering Muncul di Lomba Coding',
    category: 'Coding',
    date: 'Februari 3, 2025',
    time: '16:00',
    image: '/images/blog/commonalgorithms.jpg',
    content: <AlgoritmaCommon />,
    shortDescription: 'Kalau kamu ingin menang lomba coding, ada beberapa algoritma yang wajib banget kamu kuasai. Algoritma-algoritma ini hampir selalu muncul dalam soal karena kemampuannya menyelesaikan berbagai jenis permasalahan secara efisien.'
  },
  {
    id: '8',
    slug: slugify('Kenapa Anak Muda Harus Ikut Lomba Coding?'),
    title: 'Kenapa Anak Muda Harus Ikut Lomba Coding?',
    category: 'Coding',
    date: 'Maret 4, 2025',
    time: '16:00',
    image: '/images/blog/competitive-programming-win.jpg',
    content: <KenapaCoding />,
    shortDescription: 'Ikut lomba coding bukan cuma buat yang udah jago ngoding. Justru, ini adalah kesempatan emas buat anak muda yang ingin tumbuh dan bersaing di dunia teknologi. Berikut alasan kenapa kamu harus coba terjun ke kompetisi coding.'
  },
  {
    id: '8',
    slug: slugify('3 Website Latihan Coding Gratis yang Wajib Dicoba'),
    title: '3 Website Latihan Coding Gratis yang Wajib Dicoba',
    category: 'Coding',
    date: 'April 26, 2025',
    time: '16:00',
    image: '/images/blog/leetcode.jpg',
    content: <WebsiteCoding />,
    shortDescription: 'Mau jago ngoding tapi bingung mulai dari mana? Tenang, sekarang banyak platform online yang bisa kamu akses secara gratis untuk latihan coding.'
  },
  {
    id: '8',
    slug: slugify('Belajar Coding Itu Gak Harus Sulit!'),
    title: 'Belajar Coding Itu Gak Harus Sulit!',
    category: 'Coding',
    date: 'Mei 28, 2025',
    time: '16:00',
    image: '/images/blog/learningtocode.jpg',
    content: <GakHarusSulit />,
    shortDescription: 'Banyak yang mikir belajar ngoding itu ribet dan cuma buat orang jenius. Padahal kenyataannya enggak, kok! Dengan cara yang tepat, kamu bisa mulai belajar coding dengan mudah dan menyenangkan.'
  },
  {
    id: '9',
    slug: slugify('Python vs JavaScript: Bahasa Pemrograman Mana yang Lebih Cocok untuk Pemula?'),
    title: 'Python vs JavaScript: Bahasa Pemrograman Mana yang Lebih Cocok untuk Pemula?',
    category: 'Coding',
    date: 'Mei 2, 2025',
    time: '16:00',
    image: '/images/blog/python-vs-javascript.png',
    content: <PythonVsJavaScript />,
    shortDescription: 'Perbandingan mendalam antara Python dan JavaScript sebagai bahasa pertama untuk pemula. Artikel ini menganalisis sintaks, ekosistem pembelajaran, dan prospek karir dari kedua bahasa pemrograman paling populer di dunia.'
  },
  {
    id: '10',
    slug: slugify('Ethical Hacking dengan Python: Dasar-Dasar Keamanan Siber'),
    title: 'Ethical Hacking dengan Python: Dasar-Dasar Keamanan Siber',
    category: 'Coding',
    date: 'Juni 30, 2025',
    time: '10:00',
    image: '/images/blog/ethical-hacking.png',
    content: <EthicalHackingPython />,
    shortDescription: 'Panduan praktis memulai ethical hacking menggunakan Python. Pelajari tools dasar, proyek nyata, dan aspek legalitas keamanan siber untuk pemula.'
  },
  {
    id: '10',
    slug: slugify('Apa Itu Robotika? Pengantar Singkat untuk Pemula'),
    title: 'Apa Itu Robotika? Pengantar Singkat untuk Pemula',
    category: 'Robotic',
    date: 'Januari 28, 2025',
    time: '16:00',
    image: '/images/blog/apaiturobotika.jpg',
    content: <ApaItuRobotika />,
    shortDescription: 'Robotika adalah cabang ilmu multidisiplin yang memadukan mekanika (gerakan dan struktur fisik robot), elektronika (penggunaan sensor, aktuator, dan rangkaian kontrol), serta pemrograman (logika dan instruksi digital)'
  },
  {
    id: '10',
    slug: slugify('5 Komponen Utama yang Menyusun Sebuah Robot'),
    title: '5 Komponen Utama yang Menyusun Sebuah Robot',
    category: 'Robotic',
    date: 'Februari 10, 2025',
    time: '16:00',
    image: '/images/blog/komponenrobot.jpg',
    content: <KomponenUtama />,
    shortDescription: 'Robot bukan sekadar kotak dengan roda yang bisa bergerak. Di balik setiap gerakan dan respons robot, ada sistem kompleks yang terdiri dari berbagai komponen utama—masing-masing memiliki peran penting, seperti organ tubuh manusia yang bekerja sama. Yuk, kenali satu per satu komponen vital yang membentuk sebuah robot!'
  },
  {
    id: '10',
    slug: slugify('Kenapa Ikut Lomba Robotik Itu Keren?'),
    title: 'Kenapa Ikut Lomba Robotik Itu Keren?',
    category: 'Robotic',
    date: 'Maret 23, 2025',
    time: '16:00',
    image: '/images/blog/lombarobot.jpg',
    content: <LombaRobotKeren />,
    shortDescription: 'Lomba robotik bukan sekadar kompetisi untuk jadi juara. Ia adalah pengalaman belajar yang menyeluruh—menggabungkan ilmu pengetahuan, seni, kreativitas, strategi, dan kerja sama tim dalam satu wadah. Dari tantangan teknis hingga euforia saat robot berhasil bergerak sesuai rencana, semua jadi momen yang tak terlupakan.'
  },
  {
    id: '10',
    slug: slugify('Perbedaan Robot Otomatis dan Robot yang Bisa Diprogram'),
    title: 'Perbedaan Robot Otomatis dan Robot yang Bisa Diprogram',
    category: 'Robotic',
    date: 'April 4, 2025',
    time: '16:00',
    image: '/images/blog/robototomatis.jpg',
    content: <PerbedaanRobot />,
    shortDescription: 'Sebelum kamu mulai merancang atau merakit robot pertamamu, penting untuk mengenal dua kategori dasar robot yang sering ditemukan dalam dunia robotika. Keduanya punya fungsi yang hebat, tetapi perbedaan cara kerja dan fleksibilitasnya bisa memengaruhi bagaimana kamu mendesain robotmu.'
  },
  {
    id: '10',
    slug: slugify('Bahasa Pemrograman Terbaik untuk Proyek Robotik Pemula'),
    title: 'Bahasa Pemrograman Terbaik untuk Proyek Robotik Pemula',
    category: 'Robotic',
    date: 'Mei 2, 2025',
    time: '16:00',
    image: '/images/blog/bahasapemrogramanrobot.jpg',
    content: <BahasaRobotik />,
    shortDescription: 'Ingin bikin robot sederhana tapi bingung pakai bahasa pemrograman apa? Tenang! Berikut beberapa bahasa yang paling sering dipakai dalam proyek robotik pemula, lengkap dengan kelebihan dan kekurangannya'
  },
  {
    id: '11',
    slug: slugify('Robot Pertanian Cerdas: Solusi untuk Petani Modern'),
    title: 'Robot Pertanian Cerdas: Solusi untuk Petani Modern',
    category: 'Robotic',
    date: 'Juni 30, 2025',
    time: '09:00',
    image: '/images/blog/farming-robot.png',
    content: <RobotPertanianCerdas />,
    shortDescription: 'Eksplorasi inovasi robotika dalam sektor pertanian Indonesia. Temukan bagaimana teknologi autonomous dan AI membantu meningkatkan produktivitas hingga 300%.'
  },
  {
    id: '12',
    slug: slugify('5 Proyek Robotik Sederhana yang Bisa Dibuat di Rumah'),
    title: '5 Proyek Robotik Sederhana yang Bisa Dibuat di Rumah',
    category: 'Robotic',
    date: 'Juli 20, 2025',
    time: '11:00',
    image: '/images/blog/robotic-rumahan.png',
    content: <ProyekRobotikRumahan />,
    shortDescription: 'Panduan praktis membangun robot sederhana dengan budget minim. Lima proyek menarik menggunakan Arduino dan komponen lokal tersedia di pasaran.'
  },
  {
    id: '13',
    slug: slugify('Mengubah Dunia dengan Kecerdasan Buatan'),
    title: 'Mengubah Dunia dengan Kecerdasan Buatan',
    category: 'Technology Creative',
    date: 'April 30, 2024',
    time: '13:00',
    image: '/images/blog/ai-changing-world.png',
    content: <AIChangingTheWorld />,
    shortDescription: 'Kecerdasan Buatan (AI) telah merevolusi banyak sektor kehidupan kita, mulai dari industri hingga kehidupan sehari-hari. Dalam beberapa tahun terakhir, kita telah melihat AI mempengaruhi hampir setiap aspek kehidupan, dari mobil otonom hingga asisten virtual seperti Siri dan Alexa.'
  },
  {
    id: '14',
    slug: slugify('Mengapa Sekolah di Finlandia Mulai Ajarkan Coding Sejak TK?'),
    title: 'Mengapa Sekolah di Finlandia Mulai Ajarkan Coding Sejak TK?',
    category: 'Coding',
    date: 'Juli 30, 2025',
    time: '10:00',
    image: '/images/blog/kids-coding.jpeg',
    content: <CodingDiFinlandia />,
    shortDescription: 'Belajar dari Finlandia yang sukses mengajarkan konsep coding sejak usia dini tanpa komputer. Bagaimana Indonesia bisa mengadaptasi pendekatan ini?'
  },
  {
    id: '15',
    slug: slugify('AI dalam Seni: Ketika Kecerdasan Buatan Menjadi Pelukis dan Penyair'),
    title: 'AI dalam Seni: Ketika Kecerdasan Buatan Menjadi Pelukis dan Penyair',
    category: 'Technology Creative',
    date: 'April 30, 2024',
    time: '15:00',
    image: '/images/blog/ai-seni.png',
    content: <AIDalamSeni />,
    shortDescription: 'Eksplorasi kontroversial dunia seni digital: dari lukisan AI bergaya Affandi hingga puisi algoritmik, bagaimana teknologi mengubah definisi kreativitas?'
  },
  {
    id: '16',
    slug: slugify('Generasi AI: Anak-anak yang Lebih Akrab dengan Chatbot daripada Teman Sebaya'),
    title: 'Generasi AI: Anak-anak yang Lebih Akrab dengan Chatbot daripada Teman Sebaya',
    category: 'Technology Creative',
    date: 'Juni 30, 2025',
    time: '15:00',
    image: '/images/blog/generasi-ai.png',
    content: <GenerasiAI />,
    shortDescription: 'Investigasi dampak sosial AI companion pada anak-anak: antara tutor brilian dan teman virtual yang mengisolasi. Data mengejutkan dari riset UI 2024.'
  },
  {
    id: '17',
    slug: slugify('Mitos dan Fakta Tentang Kecerdasan Buatan yang Sering Salah Dipahami'),
    title: 'Mitos dan Fakta Tentang Kecerdasan Buatan yang Sering Salah Dipahami',
    category: 'Technology Creative',
    date: 'Juli 10, 2025',
    time: '14:00',
    image: '/images/blog/mitos-ai.png',
    content: <MitosAIFakta />,
    shortDescription: 'Mengungkap 5 kesalahpahaman umum tentang AI di Indonesia berdasarkan data Kominfo 2024 dan penjelasan pakar teknologi.'
  },
  {
    id: '18',
    slug: slugify('Robot: Mengubah Dunia Industri dan Kehidupan Sehari-hari'),
    title: 'Robot: Mengubah Dunia Industri dan Kehidupan Sehari-hari',
    category: 'Robotic',
    date: 'Agustus 30, 2025',
    time: '16:00',
    image: '/images/blog/robot-industries.png',
    content: <RobotsTransformingIndustries />,
    shortDescription: 'Robot telah menjadi bagian yang tak terpisahkan dari dunia industri modern. Sejak pertama kali digunakan di pabrik otomotif pada abad ke-20, robot telah berkembang menjadi alat yang sangat penting dalam banyak sektor, termasuk kesehatan, logistik, dan bahkan layanan pelanggan.'
  },
  {
    id: '19',
    slug: slugify('Dasar-Dasar Pemrograman: Memulai dengan Coding'),
    title: 'Dasar-Dasar Pemrograman: Memulai dengan Coding',
    category: 'Coding',
    date: 'Agustus 30, 2025',
    time: '17:00',
    image: '/images/blog/programming-basic.png',
    content: <ProgrammingBasics />,
    shortDescription: 'Pemrograman adalah keterampilan yang semakin penting di dunia digital saat ini. Baik untuk membuat aplikasi web, perangkat lunak, atau sistem lainnya, pemrograman memberikan kekuatan untuk menciptakan dan mengontrol teknologi.'
  },
  {
    id: '20',
    slug: slugify('Memahami Algoritma dan Struktur Data untuk Pemrograman Efektif'),
    title: 'Memahami Algoritma dan Struktur Data untuk Pemrograman Efektif',
    category: 'Coding',
    date: 'September 30, 2025',
    time: '17:00',
    image: '/images/blog/algorithm-DS.png',
    content: <AlgorithmsAndDataStructures />,
    shortDescription: 'Salah satu aspek terpenting dalam pemrograman adalah pemilihan algoritma dan struktur data yang tepat. Kedua konsep ini memengaruhi kinerja aplikasi, seperti waktu eksekusi dan penggunaan memori.'
  },
  {
    id: '21',
    slug: slugify('Robot Penyapu Jalan: Solusi Baru Masalah Sampah Perkotaan'),
    title: 'Robot Penyapu Jalan: Solusi Baru Masalah Sampah Perkotaan',
    category: 'Robotic',
    date: 'September 30, 2025',
    time: '17:00',
    image: '/images/blog/road-robot.png',
    content: <RobotPenyapuJalan />,
    shortDescription: 'Dengan semakin pesatnya urbanisasi, masalah sampah di kawasan perkotaan menjadi semakin kompleks. Salah satu solusi inovatif yang kini mulai banyak diterapkan adalah penggunaan robot penyapu jalan.'
  },
  {
    id: '22',
    slug: slugify('Machine Learning dan Perannya dalam Kecerdasan Buatan'),
    title: 'Machine Learning dan Perannya dalam Kecerdasan Buatan',
    category: 'Technology Creative',
    date: 'Agustus 30, 2025',
    time: '17:00',
    image: '/images/blog/machine-learning.png',
    content: <MachineLearning />,
    shortDescription: 'Pembelajaran mesin (machine learning) adalah salah satu teknologi yang memungkinkan sistem untuk belajar dari data dan meningkatkan performa tanpa adanya intervensi manusia yang signifikan.'
  },
  {
    id: '23',
    slug: slugify('Tantangan Mengemudi Tanpa Tabrak! Serunya Lomba Robot Obstacle Avoidance'),
    title: 'Tantangan Mengemudi Tanpa Tabrak! Serunya Lomba Robot Obstacle Avoidance',
    category: 'Technology Creative',
    date: 'Desember 12, 2024',
    time: '11:00',
    image: '/images/blog/obstaclerobot.jpg',
    content: <TantanganMengemudi />,
    shortDescription: 'Dalam lomba ini, para peserta ditantang untuk merancang robot yang bisa bergerak sendiri dan menghindari rintangan secara otomatis. Kedengarannya mudah, tapi sebenarnya butuh perpaduan antara teknik, logika, dan strategi!'
  },
  {
    id: '23',
    slug: slugify('Duel Sengit di Arena: Sumo Robot yang Penuh Strategi dan Aksi!'),
    title: 'Duel Sengit di Arena: Sumo Robot yang Penuh Strategi dan Aksi!',
    category: 'Robotic',
    date: 'Desember 1, 2025',
    time: '11:00',
    image: '/images/blog/robotsumo.jpg',
    content: <DuelSengit />,
    shortDescription: 'Suara sorak penonton, dentuman roda, dan gesekan logam menjadi latar dari pertarungan sengit di arena sumo robot.'
  },
  {
    id: '23',
    slug: slugify('Adu Logika dan Kecepatan: Serunya Kompetisi Coding di Event IT!'),
    title: 'Adu Logika dan Kecepatan: Serunya Kompetisi Coding di Event IT!',
    category: 'Event',
    date: 'November 2, 2025',
    time: '11:00',
    image: '/images/documentation/IIT2024-Coding-2.jpg',
    content: <AduLogika />,
    shortDescription: 'Lomba coding merupakan ajang paling dinanti dalam dunia IT karena menggabungkan logika tajam, kecepatan berpikir, dan kerja sama tim dalam satu paket menantang.'
  },
  {
    id: '23',
    slug: slugify('Student Symposium: Saat Siswa Bicara Inovasi Lewat Research Paper'),
    title: 'Student Symposium: Saat Siswa Bicara Inovasi Lewat Research Paper',
    category: 'Technology Creative',
    date: 'November 10, 2024',
    time: '11:00',
    image: '/images/documentation/IIT2024-Symposium-7.jpg',
    content: <InovasiLewatResearchPaper />,
    shortDescription: 'Student Symposium adalah acara keren di mana para siswa bisa menunjukkan hasil karya atau penelitian mereka di depan teman-teman, guru, bahkan juri'
  },
  {
    id: '23',
    slug: slugify('Inovasi Tanpa Batas: Pamer Teknologi Kreatif dari Para Inovator Muda'),
    title: 'Inovasi Tanpa Batas: Pamer Teknologi Kreatif dari Para Inovator Muda',
    category: 'Event',
    date: 'Desember 7, 2025',
    time: '11:00',
    image: '/images/blog/pamerinovasi.jpg',
    content: <InovatorMuda />,
    shortDescription: 'Lomba Innovative Technology adalah panggung bagi para siswa untuk menunjukkan kreativitas dan kemampuan problem-solving mereka lewat teknologi. '
  },

  {
    id: '23',
    slug: slugify('Ragam Lomba IIT Challenge 2024'),
    title: 'Ragam Lomba IIT Challenge 2024',
    category: 'Event',
    date: 'September 30, 2024',
    time: '11:00',
    image: '/images/blog/cover-IIT-challenge.jpg',
    content: <IITChallenges />,
    shortDescription: 'Indonesia Innovative Technology Challenge (IIT Challenge) 2024 kembali hadir sebagai ajang prestisius yang mempertemukan pelajar berbakat dari berbagai penjuru Indonesia dalam bidang teknologi dan inovasi.'
  },
  {
    id: '24',
    slug: slugify('Para Pemenang Coding Junior Lomba IIT'),
    title: 'Para Pemenang Coding Junior Lomba IIT',
    category: 'Event',
    date: 'September 29, 2024',
    time: '13:00',
    image: '/images/blog/IIT-coding-junior.png',
    content: <CodingJuniorWinnersList />,
    shortDescription: 'Kompetisi Coding Python Junior dalam ajang Indonesia Innovative Technology Challenge (IIT Challenge) 2024 telah sukses menampilkan bakat-bakat muda di bidang pemrograman.'
  },
  {
    id: '24',
    slug: slugify('Para Pemenang Coding Senior Lomba IIT'),
    title: 'Para Pemenang Coding Senior Lomba IIT',
    category: 'Event',
    date: 'September 29, 2024',
    time: '13:00',
    image: '/images/blog/IIT-coding-senior.png',
    content: <CodingSeniorWinnersList />,
    shortDescription: 'Kompetisi Coding Python Senior dalam ajang Indonesia Innovative Technology Challenge (IIT Challenge) 2024 telah menampilkan persaingan sengit di antara pelajar SMA berbakat.'
  },
  {
    id: '24',
    slug: slugify('Para Pemenang Innovative Junior Lomba IIT'),
    title: 'Para Pemenang Innovative Junior Lomba IIT',
    category: 'Event',
    date: 'Januari 29, 2025',
    time: '13:00',
    image: '/images/blog/IIT-innovative-junior.png',
    content: <InnovativeJuniorWinnersList />,
    shortDescription: 'Selamat kepada Para Pemenang Innovative Junior di IIT Challenge 2024! Kompetisi ini dirancang untuk siswa tingkat dasar hingga menengah yang ditantang menciptakan solusi sederhana namun berdampak bagi masyarakat dengan pendekatan inovatif.'
  },
  {
    id: '24',
    slug: slugify('Para Pemenang Innovative Senior Lomba IIT'),
    title: 'Para Pemenang Innovative Senior Lomba IIT',
    category: 'Event',
    date: 'Februari 29, 2025',
    time: '13:00',
    image: '/images/blog/IIT-innovative-senior.png',
    content: <InnovativeSeniorWinnersList />,
    shortDescription: 'Apresiasi setinggi-tingginya kepada Para Pemenang Innovative Senior di IIT Challenge 2024! Kompetisi ini menantang pelajar SMA dan sederajat untuk merancang solusi teknologi yang aplikatif dan berdampak bagi masyarakat.'
  },
  {
    id: '24',
    slug: slugify('Para Pemenang Robot Sumo Lomba IIT'),
    title: 'Para Pemenang Robot Sumo Lomba IIT',
    category: 'Event',
    date: 'Maret 29, 2025',
    time: '13:00',
    image: '/images/blog/IIT-sumo-robot.png',
    content: <RobotSumoWinnersList />,
    shortDescription: 'Kompetisi Sumo Robot dalam ajang Indonesia Innovative Technology Challenge (IIT Challenge) 2024 telah berlangsung dengan penuh semangat dan ketegangan.'
  },
  {
    id: '24',
    slug: slugify('Para Pemenang Obstacle Robot Lomba IIT'),
    title: 'Para Pemenang Obstacle Robot Lomba IIT',
    category: 'Event',
    date: 'April 20, 2025',
    time: '13:00',
    image: '/images/blog/IIT-obstacle-robot.png',
    content: <ObstacleRobotWinnersList />,
    shortDescription: 'Selamat kepada Tim Terbaik di Lomba Obstacle Robot IIT Challenge 2024! Kompetisi ini menampilkan ketangkasan robot dalam menavigasi berbagai rintangan dengan cerdas. Inovasi, ketelitian, dan keahlian teknik diuji secara nyata.'
  },
  {
    id: '24',
    slug: slugify('Para Pemenang Student Symposium Lomba IIT'),
    title: 'Para Pemenang Student Symposium Lomba IIT',
    category: 'Event',
    date: 'Mei 29, 2025',
    time: '13:00',
    image: '/images/blog/IIT-student-symposium.png',
    content: <StudentSymposiumWinnersList />,
    shortDescription: 'Selamat kepada Para Pemenang Student Symposium di IIT Challenge 2024! Kompetisi ini menjadi wadah bagi pelajar dan mahasiswa untuk mempresentasikan hasil penelitian atau gagasan ilmiah dalam suasana akademik yang profesional.'
  },

  {
    id: '25',
    slug: slugify('Keseruan Bazaar Kuliner di IIT Challange'),
    title: 'Keseruan Bazaar Kuliner di IIT Challange',
    category: 'Event',
    date: 'Juni 19, 2025',
    time: '13:00',
    image: '/images/blog/gambar-bazaar.png',
    content: <KeseruanBazaar />,
    shortDescription: 'Tidak hanya dipenuhi inovasi teknologi dan kompetisi seru, IIT Challenge 2024 juga menghadirkan bazaar kuliner yang menggugah selera!'
  },
  {
    id: '26',
    slug: slugify('Kenalan dengan Para Juri dan Panelis di IIT Challenge 2024'),
    title: 'Kenalan dengan Para Juri dan Panelis di IIT Challenge 2024',
    category: 'Event',
    date: 'Juli 10, 2025',
    time: '13:00',
    image: '/images/blog/juri-IIT-2024.jpg',
    content: <ListJuriIIT2024 />,
    shortDescription: 'Di balik suksesnya berbagai kompetisi di IIT Challenge 2024, terdapat peran penting para juri yang telah berdedikasi menilai karya dan performa peserta dengan objektif dan profesional.'
  },
  {
    id: '27',
    slug: slugify('Peserta dari Seluruh Indonesia: Inilah Deretan Sekolah di IIT Challenge 2024'),
    title: 'Peserta dari Seluruh Indonesia: Inilah Deretan Sekolah di IIT Challenge 2024',
    category: 'Event',
    date: 'Agustus 29, 2025',
    time: '13:00',
    image: '/images/blog/IIT-school.png',
    content: <ListSekolahIIT2024 />,
    shortDescription: 'IIT Challenge 2024 kembali membuktikan semangat generasi muda Indonesia dalam berinovasi lewat teknologi dengan ratusan peserta dari berbagai daerah dan jenjang pendidikan.'
  },
  {
    id: '28',
    slug: slugify('BOSCH Rexroth Hadirkan Kassow Robots di IIT Challenge 2024'),
    title: 'BOSCH Rexroth Hadirkan Kassow Robots di IIT Challenge 2024',
    category: 'Event',
    date: 'September 29, 2025',
    time: '13:00',
    image: '/images/blog/kassow-robots.jpg',
    content: <SponsorKassow2024 />,
    shortDescription: 'Dalam semangat mendukung generasi muda Indonesia untuk terus berinovasi melalui teknologi, IIT Challenge 2024 dengan bangga menggandeng BOSCH Rexroth sebagai sponsor utama.'
  },
  {
    id: '29',
    slug: slugify('Lomba Sumo Robot Game di Era Teknologi dan Kecerdasan Buatan'),
    title: 'Lomba Sumo Robot Game di Era Teknologi dan Kecerdasan Buatan',
    category: 'Robotic',
    date: 'Oktober 18, 2025',
    time: '13:00',
    image: '/images/blog/SumoRobotTeknologi.png',
    content: <SumoRobotTeknologi />,
    shortDescription: 'Di era perkembangan teknologi yang semakin pesat, dunia robotik mengalami kemajuan signifikan seiring hadirnya sistem otomatis dan kecerdasan buatan.'
  },
  {
    id: '30',
    slug: slugify('Lomba Sumo Robot Game sebagai Sarana Belajar Teknologi Masa Kini'),
    title: 'Lomba Sumo Robot Game sebagai Sarana Belajar Teknologi Masa Kini',
    category: 'Robotic',
    date: 'November 7, 2025',
    time: '13:00',
    image: '/images/blog/SumoRobotSaranaBelajar.png',
    content: <SumoRobotSaranaBelajar />,
    shortDescription: 'Perkembangan teknologi digital dan kecerdasan buatan mendorong kebutuhan akan metode pembelajaran yang tidak hanya berbasis teori, tetapi juga praktik langsung.'
  },
  {
    id: '31',
    slug: slugify('Mengasah Logika Lewat Lomba Obstacle Avoidance Driving Robot Game'),
    title: 'Mengasah Logika Lewat Lomba Obstacle Avoidance Driving Robot Game',
    category: 'Technology Creative',
    date: 'September 10, 2025',
    time: '14:00',
    image: '/images/blog/MengasahLogikaAIObstacle.png',
    content: <MengasahLogikaAIObstacle />,
    shortDescription: 'Kemampuan robot untuk mengambil keputusan secara mandiri merupakan salah satu ciri utama teknologi kecerdasan buatan modern.'
  },
  {
    id: '31',
    slug: slugify('Obstacle Avoidance Driving Robot Game sebagai Media Pembelajaran Robotik'),
    title: 'Obstacle Avoidance Driving Robot Game sebagai Media Pembelajaran Robotik',
    category: 'Technology Creative',
    date: 'Desember 10, 2025',
    time: '15:00',
    image: '/images/blog/SaranaBelajarRobotikObstacle.png',
    content: <SaranaBelajarRobotikObstacle />,
    shortDescription: 'Perkembangan teknologi robotik mendorong metode pembelajaran yang semakin mengutamakan praktik langsung dan pemahaman sistem secara menyeluruh.'
  },
  {
    id: '31',
    slug: slugify('Student Symposium Research Paper sebagai Wadah Budaya Riset'),
    title: 'Student Symposium Research Paper sebagai Wadah Budaya Riset',
    category: 'Technology Creative',
    date: 'November 10, 2025',
    time: '15:00',
    image: '/images/blog/SymposiumPengembanganRiset.png',
    content: <SymposiumPengembanganRiset />,
    shortDescription: 'Perkembangan dunia pendidikan saat ini menuntut siswa dan mahasiswa untuk tidak hanya memahami teori, tetapi juga mampu menuangkan gagasan secara sistematis dan ilmiah.'
  },
  {
    id: '31',
    slug: slugify('Mengasah Menulis Ilmiah Lewat Student Symposium Research Paper'),
    title: 'Mengasah Menulis Ilmiah Lewat Student Symposium Research Paper',
    category: 'Technology Creative',
    date: 'Desember 10, 2025',
    time: '15:00',
    image: '/images/blog/SymposiumMenulisIlmiah.png',
    content: <SymposiumMenulisIlmiah />,
    shortDescription: 'Kemampuan menulis karya ilmiah menjadi salah satu keterampilan penting di era pendidikan modern, terutama seiring meningkatnya tuntutan akademik dan kebutuhan akan pemahaman riset yang komprehensif.'
  },
  {
    id: '32',
    slug: slugify('Program Coding Kreatif dan Inovasi'),
    title: 'Program Coding Kreatif dan Inovasi',
    category: 'Coding',
    date: 'September 10, 2025',
    time: '13:00',
    image: '/images/blog/ScratchCodingKreatif.png',
    content: <ScratchCodingKreatif />,
    shortDescription: 'Scratch Coding merupakan ajang kompetisi yang dirancang untuk memperkenalkan dan mengembangkan kemampuan pemrograman secara kreatif dan menyenangkan bagi pelajar.'
  },
  {
    id: '32',
    slug: slugify('Mengembangkan Kreativitas Anak Lewat Scratch Coding di Era Teknologi'),
    title: 'Mengembangkan Kreativitas Anak Lewat Scratch Coding di Era Teknologi',
    category: 'Coding',
    date: 'Oktober 10, 2025',
    time: '14:00',
    image: '/images/blog/MengembangkanKreatifitasScratch.png',
    content: <MengembangkanKreatifitasScratch />,
    shortDescription: 'Di tengah perkembangan teknologi yang semakin pesat, kemampuan berpikir logis dan kreatif menjadi keterampilan penting yang perlu diperkenalkan kepada pelajar sejak dini.'
  },
  {
    id: '33',
    slug: slugify('Di Balik Layar UI/UX Mobile: Tantangan yang Sering Terabaikan'),
    title: 'Di Balik Layar UI/UX Mobile: Tantangan yang Sering Terabaikan',
    category: 'Coding',
    date: 'November 10, 2025',
    time: '15:00',
    image: '/images/blog/DibalikLayarUIUX.png',
    content: <DibalikLayarUIUX />,
    shortDescription: 'Keluhan seperti aplikasi yang tampak membingungkan, navigasi yang tidak jelas, atau fitur yang sulit ditemukan masih sering ditemui di banyak aplikasi mobile saat ini.'
  },
  {
    id: '33',
    slug: slugify('Tantangan UI/UX di Era AI: Ketika Desain Harus Lebih dari Sekadar Estetika'),
    title: 'Tantangan UI/UX di Era AI: Ketika Desain Harus Lebih dari Sekadar Estetika',
    category: 'Technology Creative',
    date: 'Desember 12, 2025',
    time: '15:00',
    image: '/images/blog/TantanganUIUXEraAI.png',
    content: <TantanganUIUXEraAI />,
    shortDescription: 'Keluhan tentang aplikasi yang tampak membingungkan, tombol susah ditekan, atau fitur yang tidak intuitif bukan hal langka di dunia digital saat ini.'
  },
  {
    id: '34',
    slug: slugify('Innovative Technology Challenge: Wadah Kreativitas Generasi Muda'),
    title: 'Innovative Technology Challenge: Wadah Kreativitas Generasi Muda',
    category: 'Technology Creative',
    date: 'Oktober 12, 2025',
    time: '15:00',
    image: '/images/blog/InnovativeWadahKreatifitas.png',
    content: <InnovativeWadahKreatifitas />,
    shortDescription: 'Perkembangan teknologi yang semakin pesat menghadirkan berbagai tantangan global, mulai dari perubahan iklim, keterbatasan sumber daya, hingga kesenjangan akses pendidikan dan teknologi.'
  },
  {
    id: '34',
    slug: slugify('Innovative Technology Challenge: Ajang Inovasi Teknologi di Era AI dan Otomasi'),
    title: 'Innovative Technology Challenge: Ajang Inovasi Teknologi di Era AI dan Otomasi',
    category: 'Technology Creative',
    date: 'November 12, 2025',
    time: '15:00',
    image: '/images/blog/InnovativeAjangInovasi.png',
    content: <InnovativeAjangInovasi />,
    shortDescription: 'Perkembangan teknologi di era kecerdasan buatan dan otomasi mengubah cara manusia bekerja, belajar, dan memecahkan masalah.'
  },
  {
    id: '35',
    slug: slugify('Python Coding Challenge: Mengembangkan Logika Pemrograman'),
    title: 'Python Coding Challenge: Mengembangkan Logika Pemrograman',
    category: 'Coding',
    date: 'Oktober 12, 2025',
    time: '15:00',
    image: '/images/blog/PythonPengembanganLogika.png',
    content: <PythonPengembanganLogika />,
    shortDescription: 'Python Coding Challenge merupakan kompetisi pemrograman individu yang ditujukan bagi siswa SMP dan SMA untuk mengasah kemampuan berpikir logis, analitis, dan sistematis.'
  },
  {
    id: '35',
    slug: slugify('Python Coding Competition: Menjelajahi Dunia Pemrograman dan Inovasi Digital'),
    title: 'Python Coding Competition: Menjelajahi Dunia Pemrograman dan Inovasi Digital',
    category: 'Coding',
    date: 'Desember 12, 2025',
    time: '15:00',
    image: '/images/blog/PythonInovasiDigital.png',
    content: <PythonInovasiDigital />,
    shortDescription: 'Python Coding Competition merupakan ajang lomba pemrograman individu bagi siswa SMP dan SMA yang bertujuan membuka wawasan tentang pemrograman sebagai sarana inovasi digital.'
  },
  {
    id: '36',
    slug: slugify('Duel in Vibe Coding: Aplikasi dan Game Berbasis AI dengan Kreativitas Digital'),
    title: 'Duel in Vibe Coding: Aplikasi dan Game Berbasis AI dengan Kreativitas Digital',
    category: 'Technology Creative',
    date: 'Oktober 12, 2025',
    time: '15:00',
    image: '/images/blog/VibeCodingKreativitas.png',
    content: <VibeCodingKreativitas />,
    shortDescription: 'Duel in Vibe Coding merupakan kompetisi pemrograman kreatif yang menantang peserta untuk menciptakan aplikasi atau permainan berbasis kecerdasan buatan (Artificial Intelligence).'
  },
  {
    id: '36',
    slug: slugify('Duel in Vibe Coding: Buat Aplikasi dan Game tanpa Coding'),
    title: 'Duel in Vibe Coding: Buat Aplikasi dan Game tanpa Coding',
    category: 'Technology Creative',
    date: 'November 12, 2025',
    time: '15:00',
    image: '/images/blog/VibeCodingTanpaCoding.png',
    content: <VibeCodingTanpaCoding />,
    shortDescription: 'Duel in Vibe Coding merupakan kompetisi pemrograman kreatif yang mendorong peserta untuk menciptakan aplikasi atau game digital berbasis kecerdasan buatan (Artificial Intelligence). '
  },

];